angular
  .module('pb.core.module')

  .factory('MainMenu', [
    'MenuManager',

    function(MenuManager) {
      var menus = [];
      return new MenuManager(menus);
    }
  ]);
